<template>
  <v-select
      v-model="item"
      dir="rtl"
      :multiple="multiple"
      :clearable="clearable"
      label="Title"
      :reduce="x => x.Id"
      :options="items"
      :loading="loading"
      :selectable="x => unselectable.includes(x.Id) === false || x === val"
      @open="onOpen"
      @option:selected="$emit('selected')"
  >
    <span
        slot="no-options"
        @click="$refs.select.open = false"
    >
      {{ $t('common.noOptions') }}
    </span>
    <template #spinner>
      <div class="demo-inline-spacing">
        <b-spinner
            v-if="loading"
            class="m-0"
            small
            variant="secondary"
        />
      </div>
    </template>
  </v-select>
</template>

<script>
export default {
  name: 'bannerTypeSelect',
  props: {
    value: {
      type: [String, Number, Array],
      default: null,
    },
    type: {
      type: [String, Number],
      default: null,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: true,
    },
    unselectable: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      selected: null,
      val: this.value,
      loading: false,
      flag: false,
      items: []
    }
  },
  watch: {
    value(v) {
      this.val = v
    },
  },
  computed: {
    item: {
      get() {
        if (this.value && (this.value.length || this.multiple === false)) {
          this.get()
        }
        return this.val
      },
      set(newValue) {
        this.$emit('input', newValue)
        this.val = newValue
      },
    },
  },
  methods: {
    get() {
      if (!this.type || this.flag || this.items.length) return
      this.flag = true
      this.loading = true
      this.$http.get(this.$api.slider.getAll, { params: { type: this.type } },)
          .then(res => {
            this.items = res.data
            this.loading = false
          })
    },
    onOpen() {
      this.get()
    },
  },
}
</script>
